<div class="help-contents-wrap">

  <a class="help-close-btn" (click)="onClose($event)"></a>

  <div class="help-head-box">

    <div class="head-txt-box">표시 방법 안내</div>
  </div>


  <div class="help-body-container scroll-effect">
    <div class="help-body-box">

      <div class="help-item-box">
        <div class="item-subject-box">한국어 성조에 따른 소리의 높낮이와 음가<span class="hanja-size">音價</span></div>

        <div class="help-content-box">

          <div class="help-img-box">
            <img src="assets/img/seungjo-grp.png" alt="이미지">
          </div>
          <!--
                <div class="item-subject-box">문자 사 성<span class="hanja-size">文字四聲</span></div>
                <div class="item-con-box">문자(한자)는 평상거입으로 소리를 구분을 합니다.</div>
          -->

          <div class="help-saseung-box">
            <div class="header cell">한국어 성조</div>
            <div class="header cell">수자<span class="hanja-size">數字</span> 표지</div>
            <div class="header cell">색상 표지</div>
            <div class="header cell">기호 표지</div>

            <div class="cell"><span class="left">고 평성<span class="hanja-size">高平聲</span></span></div>
            <div class="cell">
              <div class="type-2 seungjo-5"></div>
            </div>
            <div class="cell">
              <div class="type-3 seungjo-5"></div>
            </div>
            <div class="cell">
              <div class="type-1 seungjo-5"></div>
            </div>

            <div class="cell"><span class="left">미끄러지는 소리</span></div>
            <div class="cell">
              <div class="type-2 seungjo-4"></div>
            </div>
            <div class="cell">
              <div class="type-3 seungjo-4"></div>
            </div>
            <div class="cell">
              <div class="type-1 seungjo-4"></div>
            </div>

            <div class="cell"><span class="left">거성<span class="hanja-size">去聲</span></span></div>
            <div class="cell">
              <div class="type-2 seungjo-3"></div>
            </div>
            <div class="cell">
              <div class="type-3 seungjo-3"></div>
            </div>
            <div class="cell">
              <div class="type-1 seungjo-3"></div>
            </div>

            <div class="cell"><span class="left">상성<span class="hanja-size">上聲</span></span></div>
            <div class="cell">
              <div class="type-2 seungjo-2"></div>
            </div>
            <div class="cell">
              <div class="type-3 seungjo-2"></div>
            </div>
            <div class="cell">
              <div class="type-1 seungjo-2"></div>
            </div>

            <div class="cell"><span class="left">저 평성<span class="hanja-size">低平聲</span></span></div>
            <div class="cell">
              <div class="type-2 seungjo-1"></div>
            </div>
            <div class="cell">
              <div class="type-3 seungjo-1"></div>
            </div>
            <div class="cell">
              <div class="type-1 seungjo-1"></div>
            </div>
          </div>

        </div>

      </div>

      <div class="help-item-box">
        <div class="help-top-img-grid">
          <div class="help-top-img-box help-top-img-left">
            <div class="help-top-img-title">예시1: 높낮이 표시</div>
            <img src="assets/img/word-help1.gif" alt="높낮이 표시 예시 애니메이션">
          </div>
          <div class="help-top-img-box">
            <div class="help-top-img-title">예시2: 경음(된 소리) 표시</div>
            <img src="assets/img/word-help2.gif" alt="경음(된 소리) 표시 예시 애니메이션">
          </div>
          <div class="help-top-img-box help-top-img-bottom">
            <div class="help-top-img-title">예시3: 힘줌말 표시</div>
            <img src="assets/img/word-help3.gif" alt="힘줌말 표시 예시 애니메이션">
          </div>
        </div>
      </div>

      <div class="help-item-box">
        <div class="item-subject-box">줄임표와 설명</div>

        <div class="help-ellipses-box">
          <div class="abbr-table">
            <div class="symbol other-type-box">
              <div class="other-type">예</div>
            </div>
            <div class="symbol-txt">표제어가 포함된 문장</div>
            <div class="symbol">↔</div>
            <div class="symbol-txt">반의어로서 뜻 풀이 란에 표시 함</div>

            <div class="symbol key-box">
              <div class="key-txt">명</div>
            </div>
            <div class="symbol-txt">명사</div>

            <div class="symbol key-box">
              <div class="key-txt">대</div>
            </div>
            <div class="symbol-txt">대명사</div>

            <div class="symbol key-box">
              <div class="key-txt">자</div>
            </div>
            <div class="symbol-txt">자동사</div>

            <div class="symbol key-box">
              <div class="key-txt">타</div>
            </div>
            <div class="symbol-txt">타동사</div>

            <div class="symbol key-box">
              <div class="key-txt">상</div>
            </div>
            <div class="symbol-txt">상태 변사</div>

            <div class="symbol key-box">
              <div class="key-txt">형</div>
            </div>
            <div class="symbol-txt">형용사</div>

            <div class="symbol key-box">
              <div class="key-txt">부</div>
            </div>
            <div class="symbol-txt">부사</div>

            <div class="symbol key-box">
              <div class="key-txt">의명</div>
            </div>
            <div class="symbol-txt">의존 명사</div>

            <div class="symbol key-box">
              <div class="key-txt">보동</div>
            </div>
            <div class="symbol-txt">보조 동사</div>

            <div class="symbol key-box">
              <div class="key-txt">보형</div>
            </div>
            <div class="symbol-txt">보조 형용사</div>

            <div class="symbol key-box">
              <div class="key-txt">감</div>
            </div>
            <div class="symbol-txt">감탄사</div>

            <div class="symbol key-box">
              <div class="key-txt">인대</div>
            </div>
            <div class="symbol-txt">인칭 대명사</div>

            <div class="symbol key-box">
              <div class="key-txt">접</div>
            </div>
            <div class="symbol-txt">접사</div>

            <div class="symbol key-box">
              <div class="key-txt">관</div>
            </div>
            <div class="symbol-txt">관형사</div>

            <div class="symbol key-box">
              <div class="key-txt">수</div>
            </div>
            <div class="symbol-txt">수사</div>

            <div class="symbol key-box">
              <div class="key-txt">조</div>
            </div>
            <div class="symbol-txt">조사</div>

            <div class="symbol key-box">
              <div class="key-txt">어</div>
            </div>
            <div class="symbol-txt">어미</div>
          </div>
        </div>
      </div>

      <div class="help-comment-box">
        ※ 자세한 설명은 ‘베풀기’ 참조 요망
      </div>

    </div>

  <div class="help-foot-box">

    <div class="foot-msg-box">소리 자동 재생</div>

    <div class="foot-menu-box">
      <a class="foot-menu-btn type-1"
         (click)="onClose($event, true)">켜기</a>
      <a class="foot-menu-btn type-2"
         (click)="onClose($event, false)">끄기</a>
    </div>

  </div>

</div>
